import {Web, Element, ZvEvent} from '../../libs/zv';
import {YmapsMapElement} from '../../components/zv/ymaps/component';
import '../../components/zv/ymaps-autocomplete/component'
import * as Zv from '../../libs/zv';

class ShopMapElement extends YmapsMapElement {
    placemarks: ymaps.Placemark[] = [];
    center: number[];
    singlePointZoom = 10;
    geoQueryStorage: ymaps.GeoQueryResult;
    objectManager: ymaps.ObjectManager;
    constructor(){
        super();
    }
    async load(){
        // await Zv.Module.importScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', 'ymaps');
        // ymaps.ready(this.init.bind(this));
    }
    async deferredLoad(){
        await Zv.Module.importScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', 'ymaps');
        ymaps.ready(this.init.bind(this));
    }
    async init(){
        if(this.dataset.location){
            const result = await ymaps.geocode(this.dataset.location, {
                kind: 'locality',
                // boundedBy: myMap.getBounds(), // Сортировка результатов от центра окна карты
                // strictBounds: true, // Вместе с опцией boundedBy будет искать строго внутри области, указанной в boundedBy
                results: 1 // Если нужен только один результат, экономим трафик пользователей
            });
            const firstGeoObject = result.geoObjects.get(0),
                bounds = <number[][]>firstGeoObject.properties.get('boundedBy');
            // console.log(result.geoObjects.each(console.log));
            // console.log(firstGeoObject.properties.get('name'));
            // console.log(bounds);
            this.center = (<ymaps.IPointGeometry>firstGeoObject.geometry).getCoordinates()!;
            await super.init();
            this.ymap.setBounds(bounds, {
                checkZoomRange: true // проверяем наличие тайлов на данном масштабе.
            });
        }else {
            super.init();
        }
        // this.placemarkGroup.each((placemark:ymaps.Placemark)=> this.placemarks.push(placemark));
        // if(this.placemarkGroup.getLength()>1){
        //     this.clusterer.add(this.placemarks);
        // }else if(this.placemarkGroup.getLength()==1){
        //     this.ymap.setCenter((<ymaps.IPointGeometry> this.placemarkGroup.get(0).geometry).getCoordinates());
        //     this.ymap.setZoom(this.singlePointZoom);
        // }
        let searchControl = <ymaps.control.SearchControl>this.ymap.controls.get('searchControl');
        searchControl.options.set({
            noPlacemark: true,
            // size: 'large',
            fitMaxWidth: true,
            maxWidth: [30, 100, 315],
            kind: 'locality',
            placeholderContent: 'Введите название города'
        });
        this.objectManager = new ymaps.ObjectManager({
            clusterize: true,
            // gridSize: 32,
            // clusterDisableClickZoom: true
        });
        this.ymap.geoObjects.add(this.objectManager);
        this.objectManager.clusters.options.set({preset: 'islands#invertedDarkGreenClusterIcons'});
        this.objectManager.objects.options.set(this.iconLayouts.get('shop-map-icon')!);
        const filter = (<HTMLElement>document.querySelector('zv-ymaps-filter')).dataset.value;
        let pointsResponse = await Web.ajax(this.dataset.ajax!, {method: 'POST', headers:{'Content-Type': 'application/x-www-form-urlencoded'}, body: Web.objectToQueryString({filter: filter})});
        let points = await pointsResponse.json();
        this.objectManager.add(points);
        // Поиск точек находящихся на сцене
        this.geoQueryStorage = ymaps.geoQuery(this.objectManager.objects);
        this.ymap.events.add('boundschange', this.onBoundsChange.bind(this));
        this.onBoundsChange();
    }
    async onBoundsChange(e?:Event){
        let searchResult = this.geoQueryStorage.searchInside(this.ymap), placemarks:ShopListShop[] = [];
        await searchResult.each((pm:ymaps.Placemark)=>placemarks.push(<ShopListShop>pm.properties.get('itemData')));
        this.dispatchEvent(new CustomEvent('zv.shop.ymap.changed', {detail: placemarks}));
    }
    async findCloset(){
        let searchResult = await this.geoQueryStorage.getClosestTo(this.ymap.getCenter());
        await this.ymap.setCenter((<ymaps.geometry.Point>searchResult!.geometry).getCoordinates()!);
    }
}
customElements.define('zv-shops-map', ShopMapElement);
type ShopListShop = {
    id:number
    name:string
    logo:{
        '1X': {src:string}
        '2X': {src:string}
    }
    detailPageUrl:string
    medal:boolean
    eShop:string
    deliveryCapital:string
    deliveryRegional:string
    siteName:string
    siteUrl:string
    address:string
    phones:string[]
};
interface ShopListElementTemplate {
    item(item:ShopListShop):string;
    items(items:ShopListShop[]):string;
    pages(pagesCount:number, curPage?:number):string;
}
class ShopListElement extends HTMLElement {
    private _page = 0;
    private _template:ShopListElementTemplate;
    private _items:ShopListShop[] = [];
    perPage = 20;
    map?:ShopMapElement;
    itemsContainer = this.querySelector('.js-shops-list-container')!;
    pagesContainer = this.querySelector('.js-shops-list-pages-container')!;
    constructor(){
        super();
        if(this.dataset.mapId){
            this.map = <ShopMapElement>document.getElementById(this.dataset.mapId)!;
        }
        if(this.map){
            this.map.addEventListener(
                'zv.shop.ymap.changed',
                (e:CustomEvent)=> this.items = e.detail
            );
            // this.map.addEventListener(
            //     'zv.ymap.ready',
            //     ()=> this.loadItems()
            // );
        }
        this.addEventListener('click', Element.delegate('.js-shops-list-page', (e:ZvEvent)=>{
            this.page = parseInt((<HTMLElement>e.delegateTarget).innerText) - 1;
            this.itemsContainer.scrollIntoView({behavior: 'smooth', block: 'start'});
        }));
        this.addEventListener('click', Element.delegate('.js-shops-list-find-closest', async (e:ZvEvent)=>{
            if(!this.map){
                return;
            }
            await this.map.findCloset();
        }));
    }
    get items():ShopListShop[]{
        return this._items;
    }
    set items(v:ShopListShop[]){
        this._items = v;
        this._page = 0;
        this.renderItems();
    }
    get template():ShopListElementTemplate{
        return this._template;
    }
    set template(v:ShopListElementTemplate){
        this._template = v;
    }
    get page():number{
        return this._page;
    }
    set page(v:number){
        this._page = v;
        this.renderItems();
    }
    renderItems(){
        this.itemsContainer.innerHTML = this.template.items(this.items.slice(this.page * this.perPage, (this.page + 1) *this.perPage));
        this.pagesContainer.innerHTML = this.template.pages(Math.floor(this.items.length / this.perPage), this.page);
        // items.forEach((item:ShopListShop)=>{
        //
        // });
    }
}
customElements.define('zv-shops-list', ShopListElement);